import React from "react";
import { projectSelector } from "@rflocal/shared";
import { ProjectSelectorContext } from "./ProjectSelectorContext";

interface ProjectSelectorProviderProps {
    children: React.ReactNode;
}

/**
 * Provider that makes projectSelector available throughout the Rapid app
 * This follows the same pattern as the main app's useProjectSelector hook
 * but adapted for Rapid's module import structure
 */
export const ProjectSelectorProvider: React.FC<ProjectSelectorProviderProps> = ({ children }) => {
    return (
        <ProjectSelectorContext.Provider value={projectSelector}>
            {children}
        </ProjectSelectorContext.Provider>
    );
};
